module.exports = __webpack_public_path__ + "img/MW-1920.3bedb1d6.jpg";